module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/38a70367a21e2f1fb15aa59b7d367450.svg";